import { useQuery } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import { GetDealKanbanParams } from "types/crm/deal";

/** The Deals board: every lane with its first page of cards, in one call. */
export const useDealKanbanQuery = (
  params: GetDealKanbanParams = {},
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: dealQueryKeys.kanban(params),
    queryFn: () => dealApi.getDealKanban(params),
    enabled: options?.enabled ?? true,
  });
